/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Payment_Terms_Max_DiscountInputs */

const en_clients_payment_terms_max_discount = /** @type {(inputs: Clients_Payment_Terms_Max_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum discount (%)`)
};

const pt_br2_clients_payment_terms_max_discount = /** @type {(inputs: Clients_Payment_Terms_Max_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconto máximo (%)`)
};

/**
* | output |
* | --- |
* | "Maximum discount (%)" |
*
* @param {Clients_Payment_Terms_Max_DiscountInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_payment_terms_max_discount = /** @type {((inputs?: Clients_Payment_Terms_Max_DiscountInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Payment_Terms_Max_DiscountInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_payment_terms_max_discount(inputs)
	return pt_br2_clients_payment_terms_max_discount(inputs)
});